import Vue from 'vue';
import { globalState, liveEvents } from '../../../assets/js/application';
import RealtySearchBar from './bar.vue';

export async function initRealtySearch(realtySearch) {
    const events = await liveEvents(),
        headroom = await globalState.get('headroom'),
        headroomEl = headroom.getElement(),
        observer = new IntersectionObserver((entries) => {
            const entry = entries[0];

            headroomEl.classList.toggle('headroom--realty-search', !entry.isIntersecting);
        }, {});

    new Vue({
        el: realtySearch.querySelector('#realty-search-app'),
        components: { RealtySearchBar },
    });

    observer.observe(document.querySelector('.teaser'));

    events.addEventListener(
        '[data-toggle-desktop-search]',
        'click',
        () => {
            if (Foundation.MediaQuery.atLeast('page')) {
                document.body.classList.toggle('show-search-control');
            }
        },
        { passive: true },
    );
}
